import { SnakeMeta } from '@toggle/toggle';

export const TARGET_PRICE_SNAKES = {
  high: 'ibes_target_price_high',
  low: 'ibes_target_price_low',
  average: 'ibes_target_price',
};

export const getTargetPriceValues = ({
  data,
  mostRecentPrice,
  entityTag,
}: {
  data: SnakeMeta[];
  mostRecentPrice: number;
  entityTag: string;
}) => {
  const high = data.find(
    snake => snake.snake === `${entityTag}.${TARGET_PRICE_SNAKES.high}`
  );
  const average = data.find(
    snake => snake.snake === `${entityTag}.${TARGET_PRICE_SNAKES.average}`
  );
  const low = data.find(
    snake => snake.snake === `${entityTag}.${TARGET_PRICE_SNAKES.low}`
  );

  const highValue = high?.last_value;
  const averageValue = average?.last_value;
  const lowValue = low?.last_value;
  return {
    high: {
      value: highValue,
      isNegative: !!highValue && highValue < mostRecentPrice,
      currency: high?.currency,
    },
    average: {
      value: averageValue,
      isNegative: !!averageValue && averageValue < mostRecentPrice,
      currency: average?.currency,
    },
    low: {
      value: lowValue,
      isNegative: !!lowValue && lowValue < mostRecentPrice,
      currency: low?.currency,
    },
  };
};

export const getOneYearAgoDate = () => {
  const now = new Date();
  const oneYearAgo = new Date(
    now.getFullYear() - 1,
    now.getMonth(),
    now.getDate()
  );
  return oneYearAgo.toISOString().split('T')[0];
};
